if (!customElements.get('infinite-scroll')) {
  class InfiniteScroll extends HTMLElement {
    constructor () {
      super();
      this.params = {
        selectors: {
          item: '.product-item',
          lastItem: '.product-item:last-child',
          root: '.grid-outer',
        },
      };
      this.page = window.location.search;
      this.root = this.closest(this.params.selectors.root);
      this.loading = false;
      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
        rootMargin: '0px',
        threshold: 0.1,
      });
    }

    async connectedCallback () {
      await this.loadPrevPages();
      const lastProduct = this.querySelector(this.params.selectors.lastItem);
      if (lastProduct) {
        this.observer.observe(lastProduct);
      }
    }

    disconnectedCallback () {
      this.observer.disconnect();
    }

    /**
     * *
     * @returns {number}
     */
    get page () {
      return this._page;
    }

    /**
     * *
     * @param queryParams
     */
    set page (queryParams) {
      const params = new URLSearchParams(queryParams);
      let currentPage = parseInt(params.get('page'));
      if (!currentPage || isNaN(currentPage)) {
        currentPage = 1;
      }
      this._page = currentPage;
    }

    /**
     * *
     * @param value
     */
    set loading (value) {
      if (this.root) {
        if (value) {
          this.root.classList.add('is-loading');
        } else {
          this.root.classList.remove('is-loading');
        }
      }
      this._loading = value;
    }

    /**
     * *
     * @returns {*}
     */
    get loading () {
      return this._loading;
    }

    /**
     * *
     * @param entries
     * @returns {Promise<void>}
     */
    async handleIntersect (entries) {
      const [entry] = entries;
      if (entry.isIntersecting && !this.loading) {
        this.loading = true;
        await this.loadNextPage();
        this.loading = false;
      }
    }

    /**
     * *
     * @param needlePage
     * @returns {string}
     */
    getUrl (needlePage = null) {
      const sectionId = this.closest('section').getAttribute('data-section-id'),
        requestPage = needlePage !== null ? needlePage : this.page + 1,
        search = new URLSearchParams(window.location.search);
      search.set('section_id', sectionId);
      search.set('page', requestPage);
      return `${window.location.pathname}?${search.toString()}`;
    };

    /**
     * *
     * @param html
     * @returns {NodeListOf<Element>}
     */
    renderPrevPage (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const products = doc.querySelectorAll(this.params.selectors.item);
      const firstProduct = this.querySelector(this.params.selectors.item);
      if (firstProduct) {
        products.forEach(product => {
          this.insertBefore(product, firstProduct);
        });
      } else {
        products.forEach(product => {
          this.appendChild(product);
        });
      }
      return products;
    }

    /**
     * *
     * @param html
     * @returns {NodeListOf<Element>}
     */
    renderNextPage (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const products = doc.querySelectorAll(this.params.selectors.item);
      products.forEach(product => {
        this.appendChild(product);
      });
      return products;
    }

    /**
     * *
     * @returns {Promise<void>}
     */
    async loadNextPage () {
      try {
        const url = this.getUrl();
        const response = await fetch(url);
        const html = await response.text();
        const products = this.renderNextPage(html);
        if (products.length) {
          if (typeof SmartWishlistMain === 'function') {
            SmartWishlistMain();
          }
          const queryUrl = new URL(`${window.location.origin}/${url}`);
          const historyUrl = new URL(location);
          historyUrl.searchParams.set('page', queryUrl.searchParams.get('page'));
          this.page = queryUrl.searchParams;
          history.pushState({}, '', historyUrl);
          const lastProduct = this.querySelector(this.params.selectors.lastItem);
          if (lastProduct) {
            this.observer.observe(lastProduct);
          }
        } else {
          this.observer.disconnect();
        }
      } catch (error) {
        console.error('Error loading next page:', error);
      }
    }

    /**
     * *
     * @returns {Promise<void>}
     */
    async loadPrevPages () {
      if (this.page > 1) {
        this.loading = true;
        let needleStep = this.page - 1;
        let pages = [];
        while (needleStep > 0) {
          pages.push(this.getUrl(needleStep));
          needleStep--;
        }
        const html = await Promise.all(pages.map(async url => {
          const resp = await fetch(url);
          return resp.text();
        }));
        html.forEach((item, index) => {
          this.renderPrevPage(item);
        });
        this.loading = false;
      }
    }

  }

  customElements.define('infinite-scroll', InfiniteScroll);
}